import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { listJobs } from '../../../../../../insfrastructure/services/jobs'
import { StaticValues } from '../../../../../../insfrastructure/services/static_values'
import JobCard from '../../../../../components/job-card'
import searchIcon from '../../../../../../assets/icons/search.png'
import filterIcon from '../../../../../../assets/icons/filter.png'

export default class Oportunities extends Component {
    state: Record<string, any> = {
        job_types: [],
        job_results : [],
        loading_job: false,
        slides: [
          'https://d2d7ho1ae66ldi.cloudfront.net/ArquivoNoticias/7daf2200-2aca-11ed-aa6e-9587410378a2/melkor-morgoth.jpg',
          'https://images.nightcafe.studio/jobs/Qgdvd7TlGKDSABG5r7Ie/Qgdvd7TlGKDSABG5r7Ie--1--mew4h.jpg?tr=w-1600,c-at_max'
        ]
    }


    async componentDidMount() {
        setTimeout(() => {
          this.getStaticValues(); 
        });

        try {
          const job_results = (await listJobs({ offset: 0, limit: 3 })).data;
          
          this.setState({ job_results });
        } catch (error) {};
    }

    getStaticValues = async () => {
      try {  
        const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;          
        const job_types = staticValues.job_type;
    
        this.setState({ job_types });
      } catch (error) {}
    }

    render() {
        return (
            <div className='oportunities'>
              <div className='content'>
                  <h1 className='opportunities-title'>
                    <span className='first-word'>OPORTUNIDADES</span>
                    <span className='brand-name'>EMPREGA MECÂNICO</span>
                  </h1>

                  <div className='job-results'>
                  {
                      !this.state.loading_job ?
                      <>
                      {
                          this.state.job_results.length === 0 ?
                          <p>Nenhuma oportunidade encontrada</p> :
                          this.state.job_results.map((x: any, i:number) => 
                            <JobCard 
                              key={'job_'+i}
                              job={x}
                              jobTypes={this.state.job_types}
                            />
                          )
                      }
                      </> : 
                      <>
                          <p>Carregando...</p>
                      </>
                  }
                  </div>
                  {this.state.job_results.length > 0 && (
                    <div className='see-more-container'>
                      <Link to='/offers'>
                        <button className='see-more-btn'>Ver mais vagas</button>
                      </Link>
                    </div>
                  )}
              </div>
            </div>
        )
    }
}
